<template>
    <div>

        <vue-headful title="Incident OSHA Report :: MeritEHS"/>

        <h4 class="pb-sm-3 pb-2 pt-3 mb-2 mb-sm-2">
            <ol class="breadcrumb font-weight-bold m-0">
                <li class="breadcrumb-item active"><i class="fa fa-stethoscope"></i> Incident OSHA Report</li>
                <li class="ml-3">
                    <b-dropdown size="sm" variant="light" :disabled="generating">
                        <template #button-content>
                            <template v-if="generating">
                                <i class="fa fa-spin fa-spinner"></i> Generating
                            </template>
                            <template v-else>
                                <i class="fa fa-files-o"></i> OSHA Reports
                            </template>
                        </template>
                        <b-dropdown-item v-on:click="getOshaExport()"><i class="fa fa-file-excel-o"></i> Generating {{ filters['incident.Year'] ? filters['incident.Year'] : lastYear }} OSHA Report</b-dropdown-item>
                        <b-dropdown-item v-on:click="getOshaExport(true)"><i class="fa fa-file-excel-o"></i> Generate Blank OSHA Report</b-dropdown-item>
                        <b-dropdown-item v-on:click="getOshaExport(false, '301')"><i class="fa fa-file-zip-o"></i> Generate 301 Report for Each Incident</b-dropdown-item>
                    </b-dropdown>
                </li>
            </ol>
        </h4>

        <saved-filter-title :filterKey="filterKey" />

        <div class="card">
            <div class="card-body">
                <v-server-table :name="tableName" :ref="tableName" url="/incident/list" :columns="columns" :options="options">

                    <div slot="afterFilterWrapper" class="ml-md-2 ml-0 mt-md-0 mt-2 mb-md-0 mb-3 float-md-left">
                        <div class="clearfix d-md-none d-block"></div>

                        <table-filters-2 ref="oshaInciTableFilters" filterUrl="/incident/filters" v-bind:filters="filters" :emptyFilters="filterDefs" :filterKey="filterKey" @filtersChanged="refreshTableData" @filtersCleared="filtersCleared">
                            <template slot-scope="slotProps">
                                    <div class="d-sm-inline-block mb-sm-0 mb-2">
                                        <multi-select v-model="slotProps.filters['jobsite.DivisionId']" :btnLabel="(values) => ('Divisions ('+values.length+')')" :selectOptions="slotProps.filterData.divisions" :options="{multi: true}"></multi-select>
                                    </div>
                                    <div class="d-sm-inline-block">
                                        <b-form-select v-model="slotProps.filters['incident.Year']" :options="slotProps.filterData.years" size="md" class="filter-input" />
                                    </div>
                            </template>
                        </table-filters-2>

                        <div class="clearfix d-md-none d-block"></div>
                    </div>

                    <template slot="IncidentId" slot-scope="props">
                        <b-dropdown size="sm" variant="light">
                            <template slot="button-content">
                                Actions
                            </template>
                            <b-dropdown-item v-on:click="sendToView(props.row.IncidentId)">View</b-dropdown-item>
                            <b-dropdown-item v-on:click="exportOsha301(props.row.IncidentId)">OSHA 301</b-dropdown-item>
                            </b-dropdown-item>
                        </b-dropdown>
                    </template>

                    <template slot="EmpLastName" slot-scope="props">
                        <router-link :to="`/employees/view/${props.row.EmployeeId}`">{{ props.row.EmpFirstName }} {{ props.row.EmpLastName }} - {{ props.row.EmployeeNumber }}</router-link>
                    </template>

                    <template slot="IncidentDate" slot-scope="props">
                        {{ props.row.IncidentDate | moment("MM/DD/YYYY")}}
                    </template>
                </v-server-table>
            </div>
        </div>
    </div>
</template>

<script>
    import filterExtractor from '@/helpers/TableFilterExtractor';
    import customVTColDropdown from '@/components/vue-tables-2/CustomColumnDropdown';

    export default {
        data: function() {
            return {
                //Flag
                generating: false,

                tableName: "incidentOshaTable",

                columns: [
                    'IncidentId',
                    'DivisionName',
                    'OshaCaseNumber',
                    'EmpLastName',
                    'EmployeeTitle',
                    'IncidentDate',
                    'InjuryTypeName',
                    'MajorBodyPartName',
                    'SpecificBodyPartName',
                    'InjuryObjectOrSubstance',
                    'OshaOutcomeTypeName',
                    'AwayFromWorkDays',
                    'JobTransferOrRestrictionDays',
                    'OshaInjuryTypeName',
                ],

                filterDefs: {
                    'jobsite.DivisionId': [],
                    'incident.Year': null,
                },

                filterKey: 'oshaIncidentFilters',
            }
        },

        watch: {
            appliedFilter(newVal, oldVal){
                //Call the helper
                this.checkForAppliedFilter();
            },
        },

        computed: {
            lastYear(){
                //Return the last year
                return (new Date()).getFullYear() - 1;
            },

            filters(){
                //Check State
                if(this.$store.state.tableFilters.filters[this.filterKey])
                {
                    //Send it
                    return this.$store.state.tableFilters.filters[this.filterKey];
                }

                //Return Definition
                return JSON.parse(JSON.stringify(this.filterDefs));
            },

            appliedFilter(){
                //Send it
                return this.$store.state.appliedFilters[this.filterKey] ? this.$store.state.appliedFilters[this.filterKey] : null;
            },

            options(){
                return {
                    headings: {
                        IncidentId: 'Actions',
                        EmpLastName: 'Employee',
                        OshaCaseNumber: 'Case Number',
                        EmployeeTitle: 'Title',
                        DivisionName: 'Division',
                        IncidentDate: 'Date',
                        InjuryTypeName: 'Injury Type',
                        MajorBodyPartName: 'Major Body Part',
                        SpecificBodyPartName: 'Specific Body Part',
                        InjuryObjectOrSubstance: 'Object / Substance',
                        OshaOutcomeTypeName: 'Most Serious Outcome',
                        AwayFromWorkDays: 'Away from Work',
                        JobTransferOrRestrictionDays: 'Job Transfer or Restriction',
                        OshaInjuryTypeName: 'Injury / Illness',
                    },
                    saveState: true,
                    columnsDropdown: customVTColDropdown,
                    visibleColumns: this.$root.getVisibleColumnsFromState(this.tableName),
                    orderBy: {
                        ascending: false,
                        column: 'incident.IncidentDate',
                    },
                    requestAdapter: (data) => {
                        //INclude the asset
                        data.assetType = 'osha';

                        //Set the filters
                        data.filters = filterExtractor.extractFilters(this.filters);

                        //Send it
                        return data;
                    },
                    uniqueKey: 'IncidentId',
                };
            },
        },

        methods: {

            getOshaExport(blank = false, type = '300'){
                //Fire the helper
                this.generating = true;

                //Setup Filters
                var filterData = filterExtractor.extractFilters(this.filters);

                //Set Blank
                filterData.blank = blank ? 1 : null;
                filterData.year = filterData['incident.Year'];
                filterData.type = type;

                //If no year is selected, assgin previous year by default
                if(blank === false && filterData.year == null)
                {
                    //Decrement to last year
                    filterData.year = this.lastYear;

                    //Alert the user
                    this.$toastr.warning('OSHA report is generated for previous year by default when no year is selected in filter.');
                }

                //Send the get request
                this.$http.get('incident/osha/export', filterData)
                .then(response => {
                    //Open the download pge
                    window.open('/files/download/export/' + response.data.file);
                })
                .catch(err => {})
                .then(response => {
                    //Flag
                    this.generating = false;
                });
            },

            refreshTableData(filters) {
                //Set the data
                this.$refs.incidentOshaTable.setPage(1);
                this.$refs.incidentOshaTable.getData();

                //Update
                this.$forceUpdate();
            },

            filtersCleared(){
                //Reset
                this.refreshTableData();

                //Reset the Columns
                this.$refs.oshaInciTableFilters.resetColVis(this.$refs.incidentOshaTable);
            },

            // setUserFilterData(){
            //     //Call the Helper
            //     this.$refs.inspSavedFilters.setFilterParams(this.$refs.incidentOshaTable);
            // },

            checkForAppliedFilter(){
                //Check if
                if(!this.allowFilterSaving || !this.appliedFilter)
                {
                    return;
                }

                //Call the helper
                this.$refs.oshaInciTableFilters.setColVis(this.$refs.incidentOshaTable);
            },

            sendToView(IncidentId){
                //Send to view
                this.$router.push('/incidents/view/'+IncidentId);
            },

            exportOsha301(IncidentId){
                //Send it
                //window.location = '/incidents/export/301/'+IncidentId;

                //Send the get request
                this.$http.get('incident/osha/export/301/'+IncidentId)
                .then(response => {
                    //Open the download pge
                    window.open('/files/download/export/' + response.data.file);
                })
                .catch(err => {})
                .then(response => {
                    //Flag
                    this.generating = false;
                });
            },
        },

        mounted(){
            //Focus on the SEarch Input
            this.$refs.incidentOshaTable.$refs.genericFilter.focus();
        },
    }
</script>
